







































































































































































































































































































































































































































































































































































































































import { mapGetters } from 'vuex';
import * as EventUtils from '@/core/utils/events';
import TopNav from '@/web/components/navigation/TopNav.vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import HMInstructorsStack from '@/web/components/common/HMInstructorsStack.vue';
import { errorToMessage } from '@/core/utils/errors';
import { mapWithLimit } from '@/core/utils/concurrency';
import EventCollapsableDescriptionComponent from '@/web/components/events/EventCollapsableDescriptionComponent.vue';
import EventDateTimeComponent from '@/web/components/events/EventDateTimeComponent.vue';
import EventNameComponent from '@/web/components/events/EventNameComponent.vue';
import EventTypeComponent from '@/web/components/events/EventTypeComponent.vue';
import EventRepeatsComponent from '@/web/components/events/EventRepeatsComponent.vue';
import EventFreeTagComponent from '@/web/components/events/EventFreeTagComponent.vue';
import EventDurationComponent from '@/web/components/events/EventDurationComponent.vue';
import EventLocationComponent from '@/web/components/events/EventLocationComponent.vue';
import EventCancelledComponent from '@/web/components/events/EventCancelledComponent.vue';
import SendNotificationModal from '@/web/components/events/SendNotificationModal.vue';
import { EVENT_TYPE_PRIVATE } from '@/core/utils/events';
import HMSendEmailModal from '@/web/components/common/HMSendEmailModal.vue';
import HMSelectStudentModal from '@/web/components/common/HMSelectStudentModal.vue';
import EventZoomStreamingComponent from '@/web/components/events/EventZoomStreamingComponent.vue';
import EventGoogleMeetStreamingComponent from '@/web/components/events/EventGoogleMeetStreamingComponent.vue';
import EventBrowserStreamingComponent from '@/web/components/events/EventBrowserStreamingComponent.vue';
import HMDialog from '@/web/components/common/HMDialog.vue';
import { HMVideoModal } from '@/web/components/common';
import TeacherPermissionsMixin from '@/web/mixins/TeacherPermissionsMixin';
import { cleanedFileName } from '@/core/utils/utils';
import moment from 'moment';
import MediaFormModal from '@/web/components/media-library/MediaFormModal.vue';
import LibraryAddMedia from '@/web/views/admin/media-library/LibraryAddMedia.vue';
import { getStudentViewURL } from '@/web/router/custom-domain-utils';
import CustomerNotesModal from '@/web/components/customers/CustomerNotesModal.vue';

export default {
  name: 'EventDetails',
  components: {
    TopNav,
    NavItem,
    HMInstructorsStack,
    EventNameComponent,
    EventTypeComponent,
    EventCancelledComponent,
    EventCollapsableDescriptionComponent,
    EventDateTimeComponent,
    EventRepeatsComponent,
    EventDurationComponent,
    EventLocationComponent,
    EventZoomStreamingComponent,
    EventGoogleMeetStreamingComponent,
    EventBrowserStreamingComponent,
    EventFreeTagComponent,
  },
  mixins: [TeacherPermissionsMixin],
  data() {
    return {
      eventRecordings: [],
      eventRecordingsLoaded: false,
      showDescription: false,
      registerWithAttendedFields: [
        {
          title: this.$t('GENERAL.LABEL.STUDENT_NAME') as string,
          name: 'full_name',
        },
        {
          name: 'email',
          title: this.$t('GENERAL.LABEL.STUDENT_EMAIL') as string,
        },
        {
          name: 'created',
          title: this.$t('EVENTS.LABEL.REGISTRATION_DATE') as string,
        },
        {
          name: 'class-card',
          title: this.$t('PRODUCTS.LABELS.CLASSCARD') as string,
        },
        {
          name: 'is_www_registration',
          title: this.$t('EVENTS.LABEL.WELLWELLWELL_REGISTRATION') as string,
        },
        {
          name: 'status',
          title: this.$t('EVENTS.LABEL.STATUS') as string,
        },
        {
          name: 'has_notes',
          title: this.$t('PRODUCTS.TABLE.NOTES') as string,
        },
        {
          name: 'options',
        },
      ],
      waitlistFields: [
        {
          title: this.$t('GENERAL.LABEL.STUDENT_NAME') as string,
          name: 'full_name',
        },
        {
          name: 'email',
          title: this.$t('GENERAL.LABEL.STUDENT_EMAIL') as string,
        },
        {
          name: 'created',
          title: this.$t('EVENTS.LABEL.WAITLIST_REGISTRATION_DATE') as string,
        },
        {
          name: 'options',
        },
      ],
      searchRegisterWithAttended: '',
      selectedTab: 'registrations',
      searchWaitlist: '',
    };
  },
  computed: {
    ...mapGetters({
      event: 'event/event',
      teacher: 'user/teacher',
      teacherMagicCode: 'user/teacherMagicCode',
      hasEventEnded: 'event/hasEventEnded',
      isZoomConnected: 'user/isZoomConnected',
      registerWithAttended: 'event/registerWithAttended',
      registerWithAttendedNumber: 'event/registerWithAttendedNumber',
      registerWithAttendedDesc: 'event/registerWithAttendedDesc',
    }),
    tabs() {
      return [
        {
          name: 'registrations',
          title: this.$t('EVENTS.LABEL.REGISTRANTS', {
            count: this.numberOfRegistrations,
          }) as string,
        },
        {
          name: 'waitlist',
          title: this.$t('EVENTS.LABEL.WAITLIST', {
            count: this.numberOfWaitlistRegistrations,
          }) as string,
        },
      ];
    },
    eventTypeLabel() {
      const key = EventUtils.getEventTypeLabelKey(this.event.event_type);
      return this.$t(key);
    },
    eventTypeClasses() {
      return EventUtils.getEventTypeIconClasses(this.event.event_type);
    },
    eventRepeatsDayOfWeek() {
      return EventUtils.getDayName(this.event.schedule_day_of_week);
    },
    getRegistrationsStats() {
      if (!this.event?.registrations) return '';
      if (this.event.registration_limit > 0) {
        return `${this.event.registrations.length}/${this.event.registration_limit}`;
      } else {
        return `${this.event.registrations.length}`;
      }
    },
    showRegistrations() {
      return !(
        this.event.is_cancelled || this.event.event_type == EVENT_TYPE_PRIVATE
      );
    },
    isPrivateEvent() {
      return this.event.event_type == EVENT_TYPE_PRIVATE;
    },
    streamOptions() {
      const options =
        EventUtils.getEventStreamOptions(this.event.event_type) || {};
      if (!this.hasPermission('has_tokbox_streaming')) {
        return { ...options, browser: false };
      }
      return options;
    },
    studentFullName() {
      return this.event?.student?.full_name;
    },
    studentEmail() {
      return this.event?.student?.email;
    },
    numberOfInstructors() {
      return this.event?.instructors?.length || 0;
    },
    numberOfProducts() {
      return this.event?.products?.length || 0;
    },
    numberOfRegistrations() {
      return this.event?.registrations?.length || 0;
    },
    numberOfWaitlistRegistrations() {
      return this.event?.waitlist_registrations?.length || 0;
    },
    getEventAttendances() {
      return this.event.registrations.filter(r => r.attended);
    },
    numberOfAttendances() {
      if (!this.numberOfRegistrations) return 0;
      return this.getEventAttendances.length;
    },
    hasAttachments() {
      return this.event?.attachments?.length;
    },
    searchedRegisterWithAttended() {
      const search = this.searchRegisterWithAttended.toLowerCase();
      if (!search) {
        return this.registerWithAttended;
      }

      return this.registerWithAttended.filter(data => {
        const { email, full_name } = data.item.student;
        const searchString = (email + full_name).toLowerCase();
        return searchString.includes(search);
      });
    },
    searchedWaitlist() {
      const search = this.searchWaitlist.toLowerCase();
      if (!search) {
        return this.event.waitlist_registrations;
      }

      return this.event.waitlist_registrations.filter(data => {
        const { email, full_name } = data.student;
        const searchString = (email + full_name).toLowerCase();
        return searchString.includes(search);
      });
    },
    statusTexts() {
      return {
        'no-show': this.$t('EVENTS.LABEL.NO_SHOW'),
        registered: this.$t('EVENTS.LABEL.REGISTERED'),
        attended: this.$t('EVENTS.LABEL.ATTENDED'),
        recording: this.$t('EVENTS.LABEL.WATCHED_RECORDING'),
      };
    },
    hasRecordings() {
      return this.eventRecordingsLoaded && this.eventRecordings?.length;
    },
    isTwilioConnected() {
      return this.teacher.is_twilio_connected;
    },
  },
  methods: {
    cleanedFileName,
    async registerForEventFromWaitlist(
      waitlistRegistrationId,
      allowFree = false,
      allowOverflow = false
    ) {
      try {
        const response = await this.$store.dispatch(
          'event/registerFromWaitlistToEvent',
          {
            eventId: this.event.id,
            waitlistRegistrationId: waitlistRegistrationId,
            allowFree: allowFree,
            allowOverflow: allowOverflow,
          }
        );
        console.log('registerFromWaitlistToEvent.response', response);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'NOTIFICATIONS.TEXT.WAITLIST_REGISTRATION_TO_EVENT_SUCCESSFUL'
          ),
        });
        this.refreshEvent();
      } catch (error) {
        if (error?.response?.status == 406) {
          // 406 = event is full, ask teacher for capacity overflow confirmation
          this.$modal.show(HMDialog, {
            title: this.$t('EVENTS.TITLE.REGISTER_TO_EVENT'),
            subtitle: this.$t('EVENTS.TITLE.EVENT_IS_CURRENTLY_FULL'),
            text: this.$t('EVENTS.TEXT.CONFIRM_OVERRIDE_EVENT_CAPACITY'),
            confirmButton: this.$t('EVENTS.BUTTON.YES_REGISTER'),
            discardButton: this.$t('GENERAL.BUTTON.GO_BACK'),
            confirm: async () => {
              await this.registerForEventFromWaitlist(
                waitlistRegistrationId,
                allowFree,
                true
              );
            },
            discard: () => {
              this.$emit('close');
            },
          });
        } else if (error?.response?.status == 417) {
          // 417 = student doesn't have valid access to the event (no product or classcard)
          this.$modal.show(HMDialog, {
            title: this.$t('EVENTS.TITLE.REGISTER_TO_EVENT'),
            subtitle: this.$t('EVENTS.LABEL.GRANT_FREE_ACCESS'),
            text: this.$t('EVENTS.TEXT.ADD_FREE_REGISTRATION_TEXT'),
            confirmButton: this.$t('EVENTS.BUTTON.YES_REGISTER'),
            discardButton: this.$t('GENERAL.BUTTON.GO_BACK'),
            confirm: async () => {
              await this.registerForEventFromWaitlist(
                waitlistRegistrationId,
                true,
                allowOverflow
              );
            },
            discard: () => {
              this.$emit('close');
            },
          });
        } else {
          this.$notify({
            group: 'app',
            type: 'error',
            title: 'Failed to register the student to the event',
            text: errorToMessage(error.response, `Request failed: ${error}`),
            duration: -1, // stay ON
          });
        }
      }
    },
    getStudentPreviewURL(studioUrl, eventId) {
      return getStudentViewURL(
        studioUrl,
        `/event/details/${eventId}`,
        this.teacherMagicCode
      );
    },
    duration(seconds) {
      const duration = moment.duration(seconds, 'seconds');
      return moment()
        .hour(duration.hours())
        .minute(duration.minutes())
        .second(duration.seconds())
        .format('HH:mm:ss');
    },
    addRecording() {
      this.$modal.show(
        MediaFormModal,
        {
          showSelectMedia: true,
          showEditMedia: false,
          showUploadMedia: false,
          showEmbedMedia: false,
          showEmbedHtml: false,
          multiSelect: false,
          videoUploadAllowed: this.videoUploadAllowed,
        },
        { classes: ['vm--inline-modal'], clickToClose: false },
        {
          'media-selected': async (content: any) => {
            await mapWithLimit(content, c =>
              this.$store.dispatch('event/addEventRecording', {
                eventId: this.event.id,
                fileId: c.media.id,
              })
            );
            await this.loadRecordings();
          },
          'media-added': medaiData => {
            this.openNewMedia(medaiData);
          },
        }
      );
    },
    async openNewMedia(medaiData) {
      this.$modal.show(
        LibraryAddMedia,
        {
          medaiData,
          showAsModal: true,
        },
        { classes: ['vm--inline-modal'] },
        {
          'media-saved': async media => {
            console.log('media-saved', media);
          },
        }
      );
    },
    openReplayModal(recording) {
      this.$modal.show(HMVideoModal, {
        video: recording,
      });
    },
    async removeRecording(recording) {
      try {
        await this.$store.dispatch('event/deleteEventRecording', {
          eventId: this.event.id,
          recordingId: recording.id,
        });
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('NOTIFICATIONS.TEXT.RECORDING_SUCCESSFULLY_REMOVED'),
        });
        this.loadRecordings();
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to remove recording',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    shortDate(date) {
      return EventUtils.shortDate(date);
    },
    shortTime(datetime) {
      return EventUtils.shortTime(datetime);
    },
    humanizeDuration(duration) {
      return EventUtils.humanizeDuration(duration, 'minutes');
    },
    async cancelEvent() {
      try {
        await this.$store.dispatch(
          'event/deleteAllRegistrations',
          this.event.id
        );
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to cancel all registrations',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
        return;
      }
      try {
        await this.$store.dispatch('event/cancelEvent', null);
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to cancel the event',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    async deleteEvent() {
      try {
        await this.$store.dispatch('event/deleteEvent', this.event.id);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('NOTIFICATIONS.TEXT.EVENT_SUCCESSFULLY_REMOVED'),
        });
        this.$router.replace({ name: 'events-calendar' });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to remove the event',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    duplicate() {
      this.$router.push({
        name: 'events-duplicate',
        params: { id: this.event.id },
      });
    },
    edit() {
      this.$router.push({
        name: 'events-edit',
        params: { id: this.event.id },
      });
    },
    async openSendEmailToAllModal() {
      if (this.hasEventEnded) {
        this.$modal.show(
          SendNotificationModal,
          {
            attendedCount: this.numberOfAttendances,
            registerWithAttendedNumber: this.registerWithAttendedNumber,
          },
          undefined,
          { submit: this.sendEmailToAll }
        );
      } else {
        this.$modal.show(HMDialog, {
          title: this.$t('EVENTS.BUTTON.SEND_NOTIFICATION'),
          subtitle: this.$tc(
            'EVENTS.TITLE.NOTIFY_COUNT_PEOPLE',
            this.numberOfRegistrations
          ),
          text: this.$t('EVENTS.TEXT.THIS_WILL_SEND_A_NOTIFICATION_TO'),
          confirmButton: this.$t('EVENTS.BUTTON.SEND_NOTIFICATION'),
          confirm: this.sendEmailToAllRegistrants,
        });
      }
    },
    sendEmailToAll(excludeUnattended) {
      if (excludeUnattended) {
        return this.sendEmailToAllAttendees();
      } else {
        return this.sendEmailToAllRegistrants();
      }
    },
    async exportEmailsToCSV() {
      try {
        await this.$store.dispatch('event/exportEventRegistrationEmails', {
          eventId: this.event.id,
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'CSV Export failed',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    async exportWaitlistEmailsToCSV() {
      try {
        await this.$store.dispatch(
          'event/exportEventWaitlistRegistrationEmails',
          {
            eventId: this.event.id,
          }
        );
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Waitlist CSV Export failed',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    async removeAllRegistrations() {
      try {
        await this.$store.dispatch(
          'event/deleteAllRegistrations',
          this.event.id
        );
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'NOTIFICATIONS.TEXT.EVENT_REGISTRATIONS_SUCCESSFULLY_REMOVED'
          ),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to remove event registrations',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    async sendEmailToAllRegistrants() {
      this.$modal.show(HMSendEmailModal, {
        title: this.$t('GENERAL.TITLE.SEND_EMAIL_ALL_REGISTRANTS'),
        sendEmail: this._sendEmailToAllRegistrants,
      });
    },
    async _sendEmailToAllRegistrants(subject, body) {
      const payload = {
        eventId: this.event.id,
        subject,
        body,
      };
      try {
        await this.$store.dispatch('event/emailAllRegistrants', payload);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'NOTIFICATIONS.TEXT.EVENT_REGISTRANTS_SUCCESSFULLY_EMAILED'
          ),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to email all registrants',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    async sendEmailToWaitlistRegistrants() {
      this.$modal.show(HMSendEmailModal, {
        title: this.$t('GENERAL.TITLE.SEND_EMAIL_WAITLIST_REGISTRANTS'),
        sendEmail: this._sendEmailToWaitlistRegistrants,
      });
    },
    async _sendEmailToWaitlistRegistrants(subject, body) {
      const payload = {
        eventId: this.event.id,
        subject,
        body,
      };
      try {
        await this.$store.dispatch('event/emailWaitlistRegistrants', payload);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'NOTIFICATIONS.TEXT.EVENT_WAITLIST_REGISTRANTS_SUCCESSFULLY_EMAILED'
          ),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to email all waitlist registrants',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    async sendEmailToAllAttendees() {
      this.$modal.show(HMSendEmailModal, {
        title: this.$t('GENERAL.TITLE.SEND_EMAIL_ALL_ATTENDEES'),
        sendEmail: this._sendEmailToAllAttendees,
      });
    },
    async _sendEmailToAllAttendees(subject, body) {
      const payload = {
        eventId: this.event.id,
        subject,
        body,
      };
      try {
        await this.$store.dispatch('event/emailAllAttendees', payload);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'NOTIFICATIONS.TEXT.EVENT_ATTENDEES_SUCCESSFULLY_EMAILED'
          ),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to email all attendees',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    async addRegistration() {
      this.$modal.show(
        HMSelectStudentModal,
        {
          title: 'GENERAL.TITLE.SELECT_STUDENT',
          studentSelected: this._addRegistration,
        },
        {
          classes: ['vm--inline-modal'],
        }
      );
    },
    async _addRegistration(student, allowFree = false, allowOverflow = false) {
      try {
        await this.$store.dispatch('event/addEventRegistration', {
          eventId: this.event.id,
          studentId: student.id,
          allowFree,
          allowOverflow,
        });
        this.refreshEvent();
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'NOTIFICATIONS.TEXT.EVENT_REGISTRATION_SUCCESSFULLY_ADDED'
          ),
        });
      } catch (error) {
        if (error?.response?.status == 406) {
          // 406 = event is full, ask teacher for capacity overflow confirmation
          this.$modal.show(HMDialog, {
            title: this.$t('EVENTS.TITLE.REGISTER_TO_EVENT'),
            subtitle: this.$t('EVENTS.TITLE.EVENT_IS_CURRENTLY_FULL'),
            text: this.$t('EVENTS.TEXT.CONFIRM_OVERRIDE_EVENT_CAPACITY'),
            confirmButton: this.$t('EVENTS.BUTTON.YES_REGISTER'),
            discardButton: this.$t('GENERAL.BUTTON.GO_BACK'),
            confirm: async () => {
              await this._addRegistration(student, allowFree, true);
            },
            discard: () => {
              this.$emit('close');
            },
          });
        } else if (error?.response?.status == 417) {
          // 417 = student doesn't have valid access to the event (no product or classcard)
          this.$modal.show(HMDialog, {
            title: this.$t('EVENTS.TITLE.REGISTER_TO_EVENT'),
            subtitle: this.$t('EVENTS.LABEL.GRANT_FREE_ACCESS'),
            text: this.$t('EVENTS.TEXT.ADD_FREE_REGISTRATION_TEXT'),
            confirmButton: this.$t('EVENTS.BUTTON.YES_REGISTER'),
            discardButton: this.$t('GENERAL.BUTTON.GO_BACK'),
            confirm: async () => {
              await this._addRegistration(student, true, allowOverflow);
            },
            discard: () => {
              this.$emit('close');
            },
          });
        } else {
          this.$notify({
            group: 'app',
            type: 'error',
            title: 'Failed to add event registration',
            text: errorToMessage(error.response, `Request failed: ${error}`),
            duration: -1, // stay ON
          });
        }
      }
    },
    async addWaitlistRegistration() {
      this.$modal.show(
        HMSelectStudentModal,
        {
          title: 'GENERAL.TITLE.SELECT_STUDENT',
          studentSelected: this._addWaitlistRegistration,
          allowFreeVisible: false,
        },
        {
          classes: ['vm--inline-modal'],
        }
      );
    },
    async _addWaitlistRegistration(student, allowFree = false) {
      try {
        await this.$store.dispatch('event/addEventWaitlistRegistration', {
          eventId: this.event.id,
          studentId: student.id,
          allowFree,
        });
        this.refreshEvent();
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'NOTIFICATIONS.TEXT.EVENT_WAITLIST_REGISTRATION_SUCCESSFULLY_ADDED'
          ),
        });
      } catch (error) {
        if (error?.response?.status == 417) {
          // 417 = student doesn't have valid access to the event (no product or classcard)
          this.$modal.show(HMDialog, {
            title: this.$t('EVENTS.TITLE.ADD_TO_WAITLIST'),
            subtitle: this.$t('EVENTS.LABEL.GRANT_FREE_ACCESS'),
            text: this.$t('EVENTS.TEXT.ADD_FREE_WAITLIST_REGISTRATION_TEXT'),
            confirmButton: this.$t('EVENTS.BUTTON.ADD'),
            discardButton: this.$t('GENERAL.BUTTON.GO_BACK'),
            confirm: async () => {
              await this._addWaitlistRegistration(student, true);
            },
            discard: () => {
              this.$emit('close');
            },
          });
        } else {
          this.$notify({
            group: 'app',
            type: 'error',
            title: 'Failed to add waitlist registration',
            text: errorToMessage(error.response, `Request failed: ${error}`),
            duration: -1, // stay ON
          });
        }
      }
    },
    emailSingleUser(registration) {
      const userId = registration.student.id;
      const registrationId = registration.id;
      const eventId = this.event.id;

      async function _sendEmailToOneUser(subject, body) {
        const payload = {
          eventId,
          userId,
          registrationId,
          subject,
          body,
        };
        try {
          if (registration.student.is_prospect) {
            await this.$store.dispatch('event/emailOneRegistrant', payload);
          } else {
            await this.$store.dispatch('event/emailOneUser', payload);
          }
          this.$notify({
            group: 'app',
            type: 'success',
            title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
            text: this.$t('NOTIFICATIONS.TEXT.EMAIL_SUCCESSFULLY_SENT'),
          });
        } catch (error) {
          this.$notify({
            group: 'app',
            type: 'error',
            title: 'Failed to email your student',
            text: errorToMessage(error.response, `Request failed: ${error}`),
            duration: -1, // stay ON
          });
        }
      }

      this.$modal.show(HMSendEmailModal, {
        title: this.$t('GENERAL.TITLE.SEND_EMAIL_TO_USER', {
          user: registration.student.full_name,
        }),
        sendEmail: _sendEmailToOneUser,
      });
    },
    confirmDeleteRegistration(registration) {
      this.$modal.show(HMDialog, {
        title: this.$t('EVENTS.TITLE.REMOVE_EVENT_REGISTRATION'),
        text: this.$tc('EVENTS.TEXT.REMOVE_EVENT_REGISTRATION_CONFIRMATION'),
        confirmButton: this.$t('GENERAL.BUTTON.CONFIRM'),
        confirm: () => this.deleteRegistration(registration),
      });
    },
    confirmDeleteWaitlistRegistration(registration) {
      this.$modal.show(HMDialog, {
        title: this.$t('EVENTS.TITLE.REMOVE_WAITLIST_REGISTRATION'),
        text: this.$tc(
          'EVENTS.TEXT.REMOVE_EVENT_WAITLIST_REGISTRATION_CONFIRMATION'
        ),
        confirmButton: this.$t('GENERAL.BUTTON.CONFIRM'),
        confirm: () => this.deleteWaitlistRegistration(registration),
      });
    },
    async deleteRegistration(registration) {
      try {
        await this.$store.dispatch('event/removeEventRegistration', {
          eventId: this.event.id,
          registrationId: registration.id,
        });
        this.refreshEvent();
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'NOTIFICATIONS.TEXT.EVENT_REGISTRATION_SUCCESSFULLY_REMOVED'
          ),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to remove event registration',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    async deleteWaitlistRegistration(waitlistRegistration) {
      try {
        await this.$store.dispatch('event/removeEventWaitlistRegistration', {
          eventId: this.event.id,
          registrationId: waitlistRegistration.id,
        });
        this.refreshEvent();
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'NOTIFICATIONS.TEXT.EVENT_WAITLIST_REGISTRATION_SUCCESSFULLY_REMOVED'
          ),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to remove waitlist registration',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    async refreshEvent() {
      await this.$store.dispatch(
        'event/getEventDetails',
        this.$route.params.id
      );
      await this.loadRecordings();
    },
    async loadRecordings() {
      this.eventRecordings = await this.$store.dispatch(
        'event/getEventRecordings',
        this.$route.params.id
      );
      this.eventRecordingsLoaded = true;
    },
    getStatusText(status) {
      return this.statusTexts[status];
    },
    async refundRedemption(registration) {
      const customerId = registration.student.id;
      const punchId = registration.punch_id;
      await this.$store.dispatch('event/refundCustomerPunch', {
        punchId,
        customerId,
      });
      this.refreshEvent();
    },
    async teacherMarkEventAttended(eventRegistrationId) {
      try {
        this.$store.dispatch('event/teacherMarkEventAttended', {
          eventId: this.event.id,
          eventRegistrationId,
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to record event attendance',
          text: errorToMessage(error.response, `Request failed: ${error}`),
        });
      }
    },
    async teacherRemoveEventAttendance(eventRegistrationId) {
      try {
        this.$store.dispatch('event/teacherRemoveEventAttendance', {
          eventId: this.event.id,
          eventRegistrationId,
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to remove event attendance',
          text: errorToMessage(error.response, `Request failed: ${error}`),
        });
      }
    },
    downloadAttachment(file) {
      return window.open(file.storage_url, '_blank');
    },
    async showNotes(studentId) {
      this.$modal.show(CustomerNotesModal, {
        customerId: studentId,
      });
    },
  },
  mounted() {
    this.refreshEvent();
  },
};
